export default __webpack_public_path__ + "static/media/kw.969be875.svg";